export default {
  "nav.spreadsheet": "Tableur",
  "nav.guides": "Guides",
  "nav.reviews": "Avis",
  "nav.shipping": "Livraison",
  "nav.safety": "Sécurité",
  "nav.faq": "FAQ",
  "nav.visit": "Visiter le site principal",

  "hero.badge": "Centre de ressources indépendant",
  "hero.title": "USFans Spreadsheet — Votre guide complet pour acheter chez USFans",
  "hero.subtitle": "Vous cherchez un tableur USFans, un guide d'achat ou des informations fiables avant d'acheter ? Vous êtes au bon endroit. Explorez des ressources organisées, des guides produits, des informations de livraison, des conseils d'entrepôt, des recommandations de contrôle qualité, des avis et des guides de sécurité, le tout dans un centre facile à parcourir.",
  "hero.cta_primary": "Explorer USFans Spreadsheet",
  "hero.cta_secondary": "Lire le guide USFans",
  "hero.trust": "Ressource indépendante · Guides à jour · Informations pratiques · Axé sur la sécurité",
  "hero.search_placeholder": "Rechercher guides, livraison, contrôle qualité, coupons…",
  "hero.table_title": "Exemple de mise en page de tableur",
  "hero.col_product": "Produit",
  "hero.col_category": "Catégorie",
  "hero.col_reference": "Référence",
  "hero.col_qc": "QC",
  "hero.col_shipping": "Livraison",
  "hero.col_status": "Statut",
  "hero.item_1": "Article 01",
  "hero.item_2": "Article 02",
  "hero.item_3": "Article 03",
  "hero.item_4": "Article 04",
  "hero.qc_pending": "En attente",
  "hero.qc_passed": "Validé",
  "hero.ship_standard": "Standard",
  "hero.ship_express": "Express",
  "hero.status_considering": "Envisagé",
  "hero.status_ordered": "Commandé",
  "hero.status_received": "Reçu",

  "main.buy_now": "Acheter maintenant",
  "main.tagline": "Parcourez toute la collection sur notre site principal",
  "main.note": "Tous les liens produits s'ouvrent dans un nouvel onglet sur notre site principal.",

  "category.title": "Acheter par catégorie",
  "category.subtitle": "Accédez directement à n'importe quelle catégorie de produits sur le site principal.",
  "category.dropdown_label": "Choisir une catégorie",
  "category.dropdown_placeholder": "Sélectionnez une catégorie à visiter",

  "what_is.title": "Qu'est-ce qu'un tableur USFans ?",
  "what_is.body": "Un tableur USFans est une ressource structurée qui aide les acheteurs à organiser et découvrir les informations produit. Notre objectif est de rendre ces informations plus faciles à comprendre en rassemblant des guides pratiques, des ressources produit, des explications de livraison, des conseils de contrôle qualité et des références utiles au même endroit.",
  "what_is.cta": "Explorer le centre du tableur",

  "features.title": "Tout ce qu'il faut savoir sur USFans",
  "features.subtitle": "Commencez ici pour comprendre la plateforme avant d'acheter.",
  "features.spreadsheet.title": "USFans Spreadsheet",
  "features.spreadsheet.desc": "Explorez les ressources du tableur et apprenez à naviguer dans les informations produit.",
  "features.review.title": "Avis USFans",
  "features.review.desc": "Comprenez la plateforme, le processus d'achat, les avantages possibles et les points à considérer.",
  "features.shipping.title": "Coût de livraison USFans",
  "features.shipping.desc": "Découvrez ce qui peut influencer les frais de livraison et comment comparer les options disponibles.",
  "features.coupon.title": "Coupon USFans",
  "features.coupon.desc": "Découvrez où chercher les promotions actuelles et comment vérifier les informations de réduction.",
  "features.warehouse.title": "Entrepôt USFans",
  "features.warehouse.desc": "Comprenez le processus d'entrepôt, le stockage, le contrôle qualité et la préparation de l'expédition.",
  "features.legit.title": "USFans est-il fiable ?",
  "features.legit.desc": "Passez en revue les contrôles de sécurité pratiques et les questions à considérer avant d'utiliser un service d'achat.",

  "guides.title": "Commencez par les guides les plus populaires",
  "guides.subtitle": "Des ressources sélectionnées pour vous aider à acheter en toute confiance.",
  "guides.card1": "Guide du tableur USFans",
  "guides.card2": "Avis USFans",
  "guides.card3": "Guide des frais de livraison USFans",
  "guides.card4": "Guide des coupons USFans",
  "guides.card5": "Guide de l'entrepôt USFans",
  "guides.card6": "USFans est-il fiable ?",

  "why.title": "Pourquoi utiliser cette ressource ?",
  "why.subtitle": "Conçue pour rendre votre recherche d'achat plus facile et plus sûre.",
  "why.1.title": "Informations organisées",
  "why.1.desc": "Tout regroupé dans une structure claire et logique.",
  "why.2.title": "Adapté aux débutants",
  "why.2.desc": "Des explications en langage simple pour tous les niveaux.",
  "why.3.title": "Tableaux comparatifs",
  "why.3.desc": "Comparez les options côte à côte avant de décider.",
  "why.4.title": "Contenu à jour",
  "why.4.desc": "Des guides régulièrement revus et actualisés.",
  "why.5.title": "Axé sur la sécurité",
  "why.5.desc": "Des contrôles pratiques pour acheter de façon responsable.",
  "why.6.title": "Multilingue",
  "why.6.desc": "Disponible en anglais, polonais, espagnol et français.",

  "compare.title": "Comparez avant de décider",
  "compare.body": "Les différentes méthodes d'achat, options de livraison et processus peuvent impliquer des coûts, des exigences et des risques différents. Utilisez nos guides comparatifs pour comprendre les différences avant de prendre une décision.",
  "compare.cta": "Voir les comparatifs USFans",

  "safety.title": "La sécurité d'abord",
  "safety.body": "Les achats en ligne comportent des risques. Vérifiez toujours les informations actuelles, les détails de paiement, les politiques de livraison et les informations du vendeur avant d'effectuer un achat.",
  "safety.cta": "Lire le guide de sécurité USFans",

  "homeArticle.title": "Dernier guide",
  "homeArticle.subtitle": "Lisez notre guide détaillé pour débutants sur USFans Spreadsheet.",
  "homeArticle.cta": "Lire le guide complet",
  "homeArticle.read_time": "Temps de lecture : 6 min",

  "faq.title": "Questions fréquentes",
  "faq.q1": "Qu'est-ce qu'un tableur USFans ?",
  "faq.a1": "Un tableur USFans est une ressource structurée qui aide les acheteurs à organiser et découvrir les informations produit au même endroit.",
  "faq.q2": "Est-ce le site officiel d'USFans ?",
  "faq.a2": "Non. C'est une plateforme indépendante d'information et de ressources. Nous ne sommes affiliés ni approuvés par aucun vendeur spécifique.",
  "faq.q3": "Comment parcourir les produits ?",
  "faq.a3": "Utilisez le menu des catégories ou les boutons ci-dessus pour accéder directement à n'importe quelle catégorie de produits sur le site principal.",
  "faq.q4": "Publiez-vous des prix ou des coupons ?",
  "faq.a4": "Nous partageons uniquement des conseils généraux. Vérifiez toujours les prix, promotions et détails de livraison actuels directement sur le site principal.",

  "final.title": "Prêt à explorer les ressources d'USFans Spreadsheet ?",
  "final.body": "Commencez par le tableur, comparez vos options et apprenez les bases avant d'acheter.",
  "final.cta_primary": "Explorer USFans Spreadsheet",
  "final.cta_secondary": "Visiter le site principal",

  "footer.description": "Un centre de ressources multilingue et indépendant sur USFans Spreadsheet. Nous partageons des guides, des avis et des informations pratiques pour vous aider à prendre des décisions éclairées.",
  "footer.resources": "Ressources",
  "footer.company": "Entreprise",
  "footer.legal": "Légal",
  "footer.languages": "Langues",
  "footer.about": "À propos",
  "footer.editorial": "Politique éditoriale",
  "footer.contact": "Contact",
  "footer.disclaimer": "Avertissement",
  "footer.privacy": "Confidentialité",
  "footer.terms": "Conditions",
  "footer.cookies": "Cookies",
  "footer.disclaimer_text": "Ceci est un site d'information indépendant. Nous ne sommes pas la boutique officielle d'USFans et ne vendons pas de produits directement. Tous les liens produits mènent au site principal.",
  "footer.copyright": "© 2026 USFans Spreadsheet Resource Hub. Tous droits réservés.",
};